/**
 * Insurance tier tab bar for EV coverage. Wraps the design-system tabs in a
 * scroll container so many tiers or long labels stay reachable on narrow layouts.
 */
import { HorizontalNavigationTab } from "@risalabs_frontend_org/oasis-ui-kit";
import { useMemo } from "react";

export interface InsuranceTierSwitcherProps {
  tabs: { id: string; label: string }[];
  activeIndex: number;
  onTabChange: (index: number) => void;
}

/**
 * Renders tier switcher tabs; the row scrolls horizontally when content is wider than the viewport.
 *
 * @param props - Tab definitions, active index, and selection handler
 * @returns Scrollable horizontal tab bar
 */
export const EvCoverageInsuranceTierTabBar = (
  props: InsuranceTierSwitcherProps,
) => {
  const navTabs = useMemo(
    () =>
      props.tabs.map((tab, index) => ({
        value: String(index),
        label: tab.label,
      })),
    [props.tabs],
  );

  return (
    <div className="w-full min-w-0 shrink-0 overflow-x-auto">
      <HorizontalNavigationTab
        backgroundColor="#ffffff"
        rounded
        tabs={navTabs}
        activeColor="#0056D6"
        activeBackgroundColor="#F3F8FF"
        value={String(props.activeIndex)}
        onChange={(next) => {
          const idx = Number.parseInt(next, 10);
          if (!Number.isNaN(idx)) {
            props.onTabChange(idx);
          }
        }}
        className="w-max min-w-full shrink-0 border-b border-primaryGray-15"
      />
    </div>
  );
};
